import { BaseEntity } from '@base-entities';
import { IBaseTransformerRepository } from '@base-repositories';

import { MetricIndicatorTransformer } from '../transformers';

export function makeMetricIndicatorTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new MetricIndicatorTransformer<E>();
}
